const borderRadiusMedium = 4;
const borderRadiusLarge = 6;
const borderRadiusXLarge = 8;

export { borderRadiusLarge, borderRadiusMedium, borderRadiusXLarge };
//# sourceMappingURL=borders.js.map
